import { cB as e, cM as r, c as o, cNotM as c } from "../../../../_utils/cssr/index.js";
const s = e("base-close", `
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 background-color: transparent;
 color: var(--n-close-icon-color);
 border-radius: var(--n-close-border-radius);
 height: var(--n-close-size);
 width: var(--n-close-size);
 font-size: var(--n-close-icon-size);
 outline: none;
 border: none;
 position: relative;
 padding: 0;
`, [r("absolute", `
 height: var(--n-close-icon-size);
 width: var(--n-close-icon-size);
 `), o("&::before", `
 content: "";
 position: absolute;
 width: var(--n-close-size);
 height: var(--n-close-size);
 left: 50%;
 top: 50%;
 transform: translateY(-50%) translateX(-50%);
 transition: inherit;
 border-radius: inherit;
 `), c("disabled", [o("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), o("&:hover::before", `
 background-color: var(--n-close-color-hover);
 `), o("&:focus::before", `
 background-color: var(--n-close-color-hover);
 `), o("&:active", `
 color: var(--n-close-icon-color-pressed);
 `), o("&:active::before", `
 background-color: var(--n-close-color-pressed);
 `)]), r("disabled", `
 cursor: not-allowed;
 color: var(--n-close-icon-color-disabled);
 background-color: transparent;
 `), r("round", [o("&::before", `
 border-radius: 50%;
 `)])]);
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/close/src/styles/index.cssr.js
// module id = 1536
// module chunks = 41